export { ProductJsonLd, default } from "./ProductJsonLd";
export type { ProductJsonLdProps } from "./ProductJsonLd";
